export default __webpack_public_path__ + "media/devise/banner-logo-582b185a.svg";